/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiateProjectRenewalResponse
 */
export interface InitiateProjectRenewalResponse {
    /**
     * 
     * @type {string}
     * @memberof InitiateProjectRenewalResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateProjectRenewalResponse
     */
    projectConversationId: string;
}

/**
 * Check if a given object implements the InitiateProjectRenewalResponse interface.
 */
export function instanceOfInitiateProjectRenewalResponse(value: object): value is InitiateProjectRenewalResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('projectConversationId' in value) || value['projectConversationId'] === undefined) return false;
    return true;
}

export function InitiateProjectRenewalResponseFromJSON(json: any): InitiateProjectRenewalResponse {
    return InitiateProjectRenewalResponseFromJSONTyped(json, false);
}

export function InitiateProjectRenewalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateProjectRenewalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'projectConversationId': json['projectConversationId'],
    };
}

export function InitiateProjectRenewalResponseToJSON(value?: InitiateProjectRenewalResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'projectConversationId': value['projectConversationId'],
    };
}

